import HttpCliente from "../HttpCliente";

export const getPaises = (token) => {
  return new Promise((resolve, reject) => {
    HttpCliente.get("/Pais", {
      headers: {
        Authorization: `Bearer ${token}`,
        accept: "text/plain",
      },
    })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const postPais = (token, pais) => {
  return new Promise((resolve, reject) => {
    HttpCliente.post("/Pais/Crear", pais, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const putPais = (token, pais) => {
  return new Promise((resolve, reject) => {
    HttpCliente.put("/Pais/Editar", pais, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};


export const getPaisHabilitado = (token) => {
  return new Promise((resolve, reject) => {
    HttpCliente.get("/Pais/ObtenerHabilitados", {
      headers: {
        Authorization: `Bearer ${token}`,
        accept: "text/plain",
      },
    })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
